<template lang="pug">
.invitation-bulk-actions.d-flex
  v-btn.button-sm.mr-1(outlined :disabled="!canBulkEmail" @click="$emit('sendEmail')") {{ $t('invite_via_email') }}
  v-btn.button-sm.mr-1(outlined :disabled="!canBulkSms" @click="$emit('sendSms')") {{ $t('invite_via_message') }}
  v-btn.button-sm.underline(text @click="$emit('clear')") {{ $t('clear_selection') }}
</template>

<script>

export default {
  name: 'InvitationBulkActions',
  props: {
    canBulkEmail: {
      type: Boolean,
    },
    canBulkSms: {
      type: Boolean,
    },
  },
}
</script>

<style scoped>
</style>
